"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get filterPackages () {
        return filterPackages;
    },
    get getFilteredPackages () {
        return getFilteredPackages;
    }
});
const _workspacetools = require("workspace-tools");
const _hasRepoChanged = require("./hasRepoChanged.js");
function getFilteredPackages(options) {
    const { scope, since, sinceIgnoreGlobs, repoWideChanges, includeDependents, includeDependencies, logger, packageInfos, root } = options;
    // If scoped is defined, get scoped packages
    const hasScopes = Array.isArray(scope) && scope.length > 0;
    let scopedPackages = undefined;
    let filteredPackages = undefined;
    let changedPackages = undefined;
    const hasSince = typeof since !== "undefined";
    // If scope is defined, get scoped packages and return
    if (hasScopes) {
        scopedPackages = (0, _workspacetools.getScopedPackages)(scope, packageInfos);
        // return filteredPackages;
        return filterPackages({
            logger,
            packageInfos,
            scopedPackages,
            changedPackages,
            includeDependencies,
            includeDependents
        });
    } else if (hasSince) {
        try {
            changedPackages = (0, _workspacetools.getChangedPackages)(root, since, sinceIgnoreGlobs);
        } catch (e) {
            logger.warn(`An error in the git command has caused this scope run to include every package\n${e}`);
        // if getChangedPackages throws, we will assume all have changed (using changedPackage = undefined)
        }
        filteredPackages = filterPackages({
            logger,
            packageInfos,
            scopedPackages,
            changedPackages,
            includeDependencies,
            includeDependents
        });
        // If the defined repo-wide changes are detected the get all packages and append to the filtered packages.
        // This alo ensures that the modified packages are always run first.
        if ((0, _hasRepoChanged.hasRepoChanged)(since, root, repoWideChanges, logger)) {
            logger.verbose(`Repo-wide changes detected, running all packages. The following changed packages and their deps (if specified) will be run first: ${filteredPackages.join(",")}`);
            filteredPackages = [
                ...new Set(filteredPackages.concat(Object.keys(packageInfos)))
            ];
        }
        return filteredPackages;
    } else {
        // If neither scope or since is defined, return all packages
        return Object.keys(packageInfos);
    }
}
function filterPackages(options) {
    const { scopedPackages, changedPackages, packageInfos, includeDependents, includeDependencies, logger } = options;
    let filtered = [];
    // If scope is defined, use the transitive providers of the since packages up to the scope
    if (typeof scopedPackages !== "undefined" && typeof changedPackages !== "undefined") {
        // If both scoped and since are specified, we have to merge two lists:
        // 1. changed packages that ARE themselves the scoped packages
        // 2. changed package consumers (package dependents) that are within the scoped subgraph
        filtered = changedPackages.filter((pkg)=>scopedPackages.includes(pkg)).concat((0, _workspacetools.getTransitiveDependents)(changedPackages, packageInfos, scopedPackages));
        logger.verbose(`filterPackages changed within scope: ${filtered.join(",")}`);
    } else if (typeof changedPackages !== "undefined") {
        filtered = [
            ...changedPackages
        ];
        logger.verbose(`filterPackages changed: ${changedPackages.join(",")}`);
    } else if (typeof scopedPackages !== "undefined") {
        filtered = [
            ...scopedPackages
        ];
        logger.verbose(`filterPackages scope: ${scopedPackages.join(",")}`);
    } else {
        filtered = Object.keys(packageInfos);
    }
    // adds dependents (consumers) of all filtered package thus far
    if (includeDependents) {
        logger.verbose(`filterPackages running with dependents`);
        filtered = filtered.concat((0, _workspacetools.getTransitiveDependents)(filtered, packageInfos));
    }
    // adds dependencies of all filtered package thus far
    if (includeDependencies) {
        logger.verbose(`filterPackages running with dependencies`);
        filtered = filtered.concat((0, _workspacetools.getTransitiveDependencies)(filtered, packageInfos));
    }
    const unique = new Set(filtered);
    return [
        ...unique
    ];
}
